import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  .card-shadow {
    box-shadow: ${({ theme }) => theme.shadowCard};
  }
  .card-shadow-hover {
    box-shadow: ${({ theme }) => theme.shadowCardHover};
  }
`;
